// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__abtxZ","legacyBtn":"MutateMid_legacyBtn__3xXkQ"};